var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "general", title: "General Conditions" } },
    [
      _c("template", { slot: "copy" }, [
        _c(
          "ol",
          {
            staticClass: "fa-ul",
            staticStyle: {
              "--fa-li-width": "4em",
              "--margin-bottom": "var(--spacing-2xl)",
              "--margin-top": "var(--spacing-2xl)",
            },
          },
          [
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                ],
                1
              ),
              _vm._v(
                '\n        Your use of the Service is at your sole risk. The service is provided on an "as is" and "as available" basis.\n      '
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa2 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        Support for Font Awesome services is only available in English, via email.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa3 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You understand that Font Awesome uses third-party vendors and hosting partners to provide the necessary hardware, software, networking, storage, and\n        related technology required to run the Service.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa4 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You must not modify, adapt or hack the Service or modify another website so as to falsely imply that it is associated with the Service, Font Awesome,\n        or any other Font Awesome service.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa5 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service without\n        the express written permission by Font Awesome.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa6 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        We may, but have no obligation to, remove Content and Accounts containing Content that we determine in our sole discretion are unlawful, offensive,\n        threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or violates any party's intellectual property or these Terms of\n        Service.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa7 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        Verbal, physical, written or other abuse (including threats of abuse or retribution) of any Font Awesome customer, employee, member, or officer will\n        result in immediate account termination.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa8 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You understand that the technical processing and transmission of the Service, including your Content, may be transferred unencrypted and involve (a)\n        transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa9 },
                  }),
                ],
                1
              ),
              _vm._v(
                '\n        You must not upload, post, host, or transmit unsolicited email, SMSs, or "spam" messages.\n      '
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa0 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You must not transmit any worms or viruses or any code of a destructive nature.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        If your bandwidth usage significantly exceeds the average bandwidth usage (as determined solely by Font Awesome) of other Font Awesome customers, we\n        reserve the right to immediately disable your account or throttle your file hosting until you can reduce your bandwidth consumption.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa2 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        Font Awesome does not warrant that (i) the service will meet your specific requirements, (ii) the service will be uninterrupted, timely, secure, or\n        error-free, (iii) the results that may be obtained from the use of the service will be accurate or reliable, (iv) the quality of any products,\n        services, information, or other material purchased or obtained by you through the service will meet your expectations, and (v) any errors in the\n        Service will be corrected. THE TERMS SET FORTH HEREIN ARE EXCLUSIVE AND IN LIEU OF ALL OTHER EXPRESS AND IMPLIED WARRANTIES AND CONDITIONS WHATSOEVER,\n        WHETHER STATUTORY, COMMONLAW, OR OTHERWISE, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR PARTICULAR PURPOSE AND\n        SATISFACTORY QUALITY. YOU EXPRESSLY WAIVE ANY RIGHTS THAT IT MIGHT OTHERWISE HAVE.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa3 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You expressly understand and agree that Font Awesome shall not be liable for any direct, indirect, incidental, special, consequential or exemplary\n        damages, including but not limited to, damages for loss of profits, goodwill, use, data or other intangible losses (even if Font Awesome has been\n        advised of the possibility of such damages), resulting from: (i) the use or the inability to use the service; (ii) the cost of procurement of\n        substitute goods and services resulting from any goods, data, information or services purchased or obtained or messages received or transactions\n        entered into through or from the service; (iii) unauthorized access to or alteration of your transmissions or data; (iv) statements or conduct of any\n        third-party on the service; (v) or any other matter relating to the service.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa4 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        The failure of Font Awesome to exercise or enforce any right or provision of the Terms of Service shall not constitute a waiver of such right or\n        provision. The Terms of Service constitute the entire agreement between you and Font Awesome and govern your use of the Service, superseding any prior\n        agreements between you and Font Awesome (including, but not limited to, any prior versions of the Terms of Service). You agree that these Terms of\n        Service and Your use of the Service are governed under Arkansas law.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa5 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You agree to indemnify, defend, and hold harmless Font Awesome, its officers, employees, agents, successors, and assigns, against all claims and suits\n        by third parties for damages, injuries to persons (including death), damage to property, loses, and expenses including reasonable attorney's fees,\n        arising out of or from Your use of Company's products and services, including all acts by Customer pursuant to this these terms of service.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa6 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        If any provision herein, or the application of such provision to any person or circumstance, shall be held invalid by a court or arbitrator, the\n        remainder of the terms herein, or the application of such provision(s) to persons or circumstances other than those as to which it is held invalid,\n        shall not be affected thereby. The remaining terms shall be construed consistently with the terms and stated objectives herein to best give effect to\n        the parties' intent.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa7 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        The parties agree that any dispute between them relating in any way to the terms herein shall be subject to mandatory and binding arbitration. Such\n        arbitration shall be conducted by an arbitrator mutually agreeable to the parties and pursuant to the procedural rules of the American Arbitration\n        Association (the “AAA”), though the arbitration need not necessarily be conducted through the AAA. In the event the parties cannot agree to a single\n        arbitrator, each party shall select an arbitrator and the two arbitrators shall select a third, and the subject arbitration shall be conducted by the\n        three arbitrators. All costs for such arbitration shall be shared equally among the parties (with the exception of attorney's fees, which shall be\n        bourne by the party incurring such costs), and the prevailing party shall be entitled to an award of costs and fees against the non-prevailing party.\n        In the event this clause is held invalid or unenforceable, the parties agree that the sole and exclusive jurisdiction for any lawsuits related to this\n        agreement shall be in the United States District Court for the Western District of Arkansas or the state courts sitting in Bentonville, Arkansas.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa8 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        THE PARTIES HERETO AGREE THAT ANY CLAIMS BY OR AMONG THEM SHALL BE ADJUDICATED ON AN INDIVIDUAL BASIS AND EACH OF THE PARTIES EXPRESSLY WAIVES THEIR\n        RIGHT, IF ANY, TO PARTICIPATE IN A CLASS, COLLECTIVE, OR OTHER JOINT ACTION CONCERNING ANY CLAIMS BY OR AMONG THEM.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa9 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        The relationship between the parties is also governed, as applicable, by either a Font Awesome Pro License or a Font Awesome Free License (the\n        “Applicable License”). The terms of the Applicable License are incorporated into these Terms of Service by reference as if fully restated herein.\n        These Terms of Service and the Applicable License shall be read and interpreted together.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa2 },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa0 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        Questions about the Terms of Service should be sent to\n        "
              ),
              _c(
                "a",
                {
                  attrs: { href: "mailto:hello@fontawesome.com" },
                  on: {
                    click: function ($event) {
                      return _vm.supportLinkClicked(
                        "tos_view",
                        "conditions_section"
                      )
                    },
                  },
                },
                [_vm._v("hello@fontawesome.com")]
              ),
              _vm._v("\n        .\n      "),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }